//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goBack from '@/components/public-components/goBack/index.vue'
import mapList from '@/components/public-components/mapList/index.vue'
import EsQuery from '@/javascript/esQuery'
import util from '@/javascript/util'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
    name: 'culture',
    components: {
        goBack,
        mapList,
        Footer
    },
    watch: {
        '$route': function (to, from) {
            document.title = '生态专题'
        }
    },
    filters: {
    // 格式化时间戳
    formatDate (datestamp) {
      if (datestamp != null) {
        let result = new Date(Number(datestamp))
        const y = result.getFullYear()
        let m = result.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = result.getDate()
        d = d < 10 ? ('0' + d) : d
        let h = result.getHours()
        h = h < 10 ? ('0' + h) : h
        let n = result.getMinutes()
        n = n < 10 ? ('0' + n) : n
        let s = result.getSeconds()
        s = s < 10 ? ('0' + s) : s
        return `${y}-${m}-${d} ${h}:${n}`
      }
    }
  },
    data() {
        return {
            showMapList: false,
            minHeight: 0,
            mapNav: { title: "123" },
            pageNo: 0,
            pageSize: 7,
            list: [],
            infiniteAll: false,
            infiniteStatus: false,
            tabsIndex: 0,
            tabs: [{
                name: '高原动物',
                code: ''
            },{
                name: '草本植物',
                code: ''
            }],
        }    
    },
    mounted() {
        this.list.length = 0
        this.minHeight = document.documentElement.clientHeight
        document.title = '生态专题'
        this.apiList().then(data => {
            this.list = [...this.list, ...data]
            this.pageNo++
        })

        window.addEventListener("scroll", this.windowScroll)
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.windowScroll)
    },
    methods: {
        tabClick(index) {
            this.tabsIndex = index
            this.pageNo = 0
            this.list.length = 0
            this.infiniteAll = false
            this.apiList().then(data => {
                this.list = [...this.list, ...data]
                this.pageNo++
            })
        },
        windowScroll() {
            if (util.pullUpLoad()) {
                this.infinite()
            }
        },
        infinite() {
            if (this.infiniteAll) {
                return
            }
            if (this.infiniteStatus) {
                return
            }
            if (this.list.length == 0) {
                return
            }
            this.infiniteStatus = true
            this.apiList().then(data => {
                this.list = [...this.list, ...data]
                this.pageNo++
            })
        },
        apiList() {
            return new Promise((resolve, reject) => {
                const newsEsQuery = new EsQuery()
                const querystring = require('querystring')
                const catalogCode = "00000000,1720511655138"
                newsEsQuery
                    .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, newsEsQuery.and, false)
                    .addStartWith("catalogCode", catalogCode, newsEsQuery.and, false)
                    .addString("tags", this.tabsIndex == 0 ? '动物' : '植物', newsEsQuery.and, false)
                    // .addString("top", 1, newsEsQuery.and, false)
                    .addSort("createdDate", newsEsQuery.desc, false)
                    // .addString("catalogId", catalogId, newsEsQuery.and, false)
                    .addPage(this.pageNo * this.pageSize, this.pageSize)
                const newsJsList = JSON.stringify(newsEsQuery.getArray())
                this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
                    'indexName': this.INDEX_NAME_TYPE.newsList,
                    'esJsonQuery': newsJsList
                })).then(res => {
                    this.infiniteAll = res.data.data.length === 0
                    this.infiniteStatus = false


                    resolve(res.data.data)
                })
            })
        },
        goPage(path) {
            location.href = '#' + path
        }
    }
}
